<div class="container-login-btn {{disabledClass()}}" (click)="onClick($event)">
    <div>{{buttonTitle}}</div>
	<img *ngIf="buttonImage != null" class="centered" [style]="buttonImageStyle" [src]="buttonImage" alt="Cancel Button" title="Click here to Cancel" width="45px">
</div>